<template>
<div class='form-records'>
  <div class='pane'>
    <el-table :data="list" max-height="600" v-if="labels" ref="table">
      <el-table-column type="selection">
      </el-table-column>
      <el-table-column fixed label='序号' prop="seq" width='50'>
      </el-table-column>
      <el-table-column label='日期' width='180'>
        <template scope="scope">
          <span>{{dateReadable(scope.row.created_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="label.name" :prop="label.key" v-for="label in labels" :key="label.key"></el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="current_page" :page-size="page_size" layout="total, prev, pager, next" :total="total_items" style='margin-top: 20px;text-align:center;'>
    </el-pagination>
    <a class='link' @click='removeSelections'>删除选中</a>
    <a class='link' :href="`/projects/${$route.params.id}/form_records/export.xls`" target='_blank'>导出表单</a>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      combined_form: {},
      list: [],
      current_page: 1,
      total_pages: 1,
      total_items: 0,
      page_size: 1
    }
  },
  computed: {
    labels() {
      if (!this.combined_form) return null

      return Object.keys(this.combined_form).map(k => {
        return {
          key: k,
          name: this.combined_form[k]
        }
      })
    }
  },
  methods: {
    fetchData() {
      let vm = this
      vm.$store.dispatch('project/formRecords', { id: vm.$route.params.id, page: vm.current_page }).then(res => {
        vm.combined_form = res.data.combined_form
        vm.list = res.data.list
        vm.current_page = res.data.current_page
        vm.total_pages = res.data.total_pages
        vm.total_items = res.data.total_items
        vm.page_size = res.data.page_size
      })
    },
    handleCurrentChange() {
      this.fetchData()
    },
    removeSelections() {
      let vm = this
      let selections = vm.$refs['table'].store.states.selection

      if (!selections || selections.length <= 0) {
        vm.$alert('暂无选中').catch(_ => {})
        return
      }

      vm.$confirm('删除的数据暂不能恢复', '确定删除选中的数据？', {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(_ => {
        vm.$store.dispatch('project/deleteFormRecords', {
          id: vm.$route.params.id,
          batch_ids: selections.map(v => { return v.id }).join(',')
        }).then(_ => {
          // reload current page
          vm.fetchData()
        })
      }).catch(_ => {})
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// form.view.vue?2b0f14d0